import PropTypes from 'prop-types';
import { DEFAULT_PALETTE } from './spriteData';

const TOOLS = [
  { id: 'pencil', label: 'Pencil', hint: 'Draw with the selected colour' },
  { id: 'eraser', label: 'Eraser', hint: 'Clear to transparent' },
  { id: 'fill', label: 'Fill', hint: 'Flood fill a contiguous region' },
  { id: 'picker', label: 'Pick', hint: 'Sample a colour from the canvas' },
];

export default function Palette({
  color, onColor, tool, onTool, showGrid, onToggleGrid,
}) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Tool</h3>
        <div className="grid grid-cols-2 gap-1">
          {TOOLS.map((t) => (
            <button
              key={t.id}
              type="button"
              title={t.hint}
              onClick={() => onTool(t.id)}
              className={`px-2 py-1.5 text-xs rounded transition-colors ${
                tool === t.id
                  ? 'bg-primary text-navy font-semibold'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">
          Palette
        </h3>
        <div className="grid grid-cols-6 gap-1">
          {DEFAULT_PALETTE.map((c) => (
            <button
              key={c}
              type="button"
              title={c}
              aria-label={`Colour ${c}`}
              onClick={() => onColor(c)}
              style={{ backgroundColor: c }}
              className={`h-7 rounded border-2 transition-transform ${
                color.toLowerCase() === c.toLowerCase()
                  ? 'border-white scale-110'
                  : 'border-transparent hover:border-gray-500'
              }`}
            />
          ))}
        </div>
      </div>

      {/*
        Controls are nested inside their labels AND carry htmlFor/id. The
        airbnb a11y config asserts both, and it is the more robust pairing
        anyway — clicking the text activates the control either way.
      */}
      <label htmlFor="custom-color" className="block">
        <span className="block text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">
          Custom
        </span>
        <span className="flex items-center gap-2">
          <input
            id="custom-color"
            type="color"
            value={color}
            onChange={(e) => onColor(e.target.value)}
            className="h-8 w-12 rounded bg-gray-800 border border-gray-700 cursor-pointer"
          />
          <code className="text-xs text-gray-400">{color}</code>
        </span>
      </label>

      <label
        htmlFor="show-grid"
        className="flex items-center gap-2 text-xs text-gray-400 cursor-pointer"
      >
        <input
          id="show-grid"
          type="checkbox"
          checked={showGrid}
          onChange={onToggleGrid}
          className="rounded border-gray-600"
        />
        Show pixel grid
      </label>
    </div>
  );
}

Palette.propTypes = {
  color: PropTypes.string.isRequired,
  onColor: PropTypes.func.isRequired,
  tool: PropTypes.string.isRequired,
  onTool: PropTypes.func.isRequired,
  showGrid: PropTypes.bool.isRequired,
  onToggleGrid: PropTypes.func.isRequired,
};
